import { useContext } from 'react';
import { BusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/context/BusinessInsightsProvider';
import { BusinessInsightsContextValue } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/businessInsightsContext';

export const useBusinessInsightsContext = (): BusinessInsightsContextValue => {
  const context = useContext(BusinessInsightsContext);

  if (context === null) {
    throw new Error(
      'useBusinessInsightsContext must be used within a BusinessInsightsProvider'
    );
  }

  return context;
};
